import { cx } from "@emotion/css";
import { forwardRef } from "react";

import { InputErrorMessageProps } from "@/modules/form/components/ErrorMessage/InputErrorMessage";
import { Radio } from "@/modules/form/components/Radio/Radio";
import { RadioGroup } from "@/modules/form/components/RadioGroup/RadioGroup";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createTestQuestionStyles } from "./createTestQuestionStyles";

type Answer = {
  id: string;
  value: string;
  label: string;
};

type TestQuestionProps = {
  question: string;
  answers: Answer[];
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
} & InputErrorMessageProps;

export const TestQuestion = forwardRef<HTMLInputElement, TestQuestionProps>(
  (
    { question, answers, name, onChange, error, errorMessages, ErrorMessage },
    ref
  ) => {
    const classes = createTestQuestionStyles(useTheme());
    return (
      <div className={classes.root}>
        <p className={classes.question}>{question}</p>
        <RadioGroup
          name={name}
          error={error}
          errorMessages={errorMessages}
          ErrorMessage={ErrorMessage}
        >
          {answers.map((answer) => (
            <Radio
              name={name}
              error={error}
              onChange={onChange}
              value={answer.value}
              id={answer.id}
              key={answer.id}
              ref={ref}
              label={answer.label}
              hideError
              labelClassName={cx(classes.answerLabel, {
                [classes.errorAnswerLabel]: Boolean(error),
              })}
              className={classes.answerRadio}
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
);
